/* A layout controller only: retain APO controls, pricing, upload handlers and cart submission. */
(() => {
  'use strict';
  const boot = () => {
    const root = document.getElementById('sc-barrel-ordering-design');
    const product = document.getElementById('ProductSection');
    if (!root || !product || root.dataset.productHandle !== 'custom-barrel-sauna-cover') return;
    const form = product.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const groups = [
      ['1989409','1989410','1989411','1989414','1989415'],
      ['1989413','1989416'],
      ['1989421'],
      ['1989086','1989087','1989088','1989089','1989090','1989091','2098161','2071233']
    ];
    const pages = [...root.querySelectorAll('[data-sc-order-page]')];
    const destinations = pages.map(p => p.querySelector('[data-sc-order-fields]'));
    const progress = [...root.querySelectorAll('[data-sc-order-step]')];
    const next = root.querySelector('[data-sc-order-next]');
    const back = root.querySelector('[data-sc-order-back]');
    const status = root.querySelector('[data-sc-order-status]');
    let step = 0, mounted = false, queued = false;
    let photoDisclosure, hasChoices = false;
    const syncPhotos = () => {
      if (!photoDisclosure) return;
      const selected = groups.flat().some(id => {
        const option = document.getElementById('o_'+id);
        if (!option || option.closest('.mw-hidden,[hidden]')) return false;
        return [...option.querySelectorAll('select,input[type="radio"],input[type="checkbox"]')].some(field => {
          if (field.matches(':disabled') || field.closest('.mw-hidden,[hidden]')) return false;
          return field.tagName === 'SELECT' ? !!field.value.trim() : field.checked;
        });
      });
      if (selected && !hasChoices) photoDisclosure.open = false;
      else if (!selected && hasChoices) photoDisclosure.open = true;
      hasChoices = selected;
    };
    const shown = el => !!el && !el.closest('[hidden],.mw-hidden') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const move = (el,dest) => { if (el && el.parentElement !== dest) dest.append(el); };
    const paintStep = (n,focus = false) => {
      step = n;
      form.dataset.scOrderStage = String(n);
      pages.forEach((p,i) => {
        p.removeAttribute('hidden');
        p.dataset.active = String(i === n);
        p.inert = i !== n;
        p.setAttribute('aria-hidden', String(i !== n));
      });
      progress.forEach((b,i) => {
        if (i === n) b.setAttribute('aria-current','step');
        else b.removeAttribute('aria-current');
      });
      back.hidden = n === 0;
      next.hidden = n === 3;
      next.textContent = n === 2 ? 'Continue to review' : 'Continue';
      status.textContent = '';
      if (focus) {
        const heading = pages[n].querySelector('h3');
        heading.tabIndex = -1;
        heading.focus({preventScroll:true});
        requestAnimationFrame(() => requestAnimationFrame(() => root.scrollIntoView({behavior:'instant',block:'start'})));
      }
      product.dispatchEvent(new CustomEvent('sc:ordering-step',{detail:{step:n}}));
    };
    const optionsIn = n => [...pages[n].querySelectorAll('.mw-option')].filter(shown);
    const fail = (field,message,n) => {
      paintStep(n,true);
      status.textContent = message;
      if (field) {
        field.focus({preventScroll:true});
        field.scrollIntoView({block:'center',behavior:'instant'});
        if (field.validity && !field.validity.valid) field.reportValidity();
      }
      return false;
    };
    const validate = n => {
      for (const option of optionsIn(n)) {
        if (!option.classList.contains('mw-option--required')) continue;
        const inputs = [...option.querySelectorAll('input:not([type="hidden"]),select,textarea')].filter(el => !el.disabled && shown(el));
        const field = inputs.find(el => el.tagName === 'SELECT' || ['text','number','email','tel','radio','checkbox','file'].includes(el.type) || el.tagName === 'TEXTAREA');
        if (!field) continue;
        const label = option.querySelector('.mw-option__title,label')?.textContent.replace(/\s*\*\s*$/,'').trim() || 'this option';
        let missing = false;
        if (field.type === 'radio' || field.type === 'checkbox') missing = !inputs.some(el => el.checked);
        else if (field.type === 'file') missing = !option.querySelector('[data-filepond-item-state="processing-complete"]');
        else missing = !field.value.trim();
        if (missing) return fail(field,`Please complete ${label}.`,n);
      }
      for (const field of pages[n].querySelectorAll('input,select,textarea')) {
        if (field.disabled || !shown(field) || field.type === 'hidden' || field.type === 'file') continue;
        const dimension = field.matches('[data-sc-measure],[data-sc-corner-supplement],#sc-front-door-width') || /^o_1989414$/.test(field.closest('.mw-option')?.id || '');
        if (dimension && field.value && !/^\d+\.(?:00|25|50|75)$/.test(field.value.trim())) return fail(field,'Enter whole inches, a decimal point, and .00, .25, .50 or .75 (for example, 48.25).',n);
        if (dimension && field.value && field.hasAttribute('max') && Number(field.value) > Number(field.getAttribute('max'))) return fail(field,`Enter a measurement up to ${field.getAttribute('max')} inches.`,n);
        if (!field.checkValidity()) return fail(field,field.validationMessage || 'Please check this field.',n);
      }
      status.textContent = '';
      return true;
    };
    const mount = () => {
      queued = false;
      const container = product.querySelector('.mw-apo-container');
      if (!container || !groups.flat().every(id => product.querySelector('#o_'+id))) return;
      // Keep the same APO container and real form controls so delegated app events remain intact.
      if (!mounted) container.prepend(root);
      groups.forEach((ids,i) => ids.forEach(id => {
        const option = document.getElementById('o_'+id);
        if (i === 2 && option.closest('.sc-color-choices')) move(option.closest('.sc-color-choices'),destinations[i]);
        else move(option,destinations[i]);
      }));
      if (!mounted) {
        const gallery = product.querySelector('.sc-product-gallery');
        const photos = gallery && [...gallery.children].filter(el => el.classList.contains('grid') || el.classList.contains('sc-highlights'));
        if (photos?.length && !gallery.querySelector('[data-sc-order-photos]')) {
          const disclosure = document.createElement('details');
          disclosure.dataset.scOrderPhotos = '';
          disclosure.open = true;
          const title = document.createElement('summary');
          title.textContent = 'View product photos & details';
          disclosure.append(title,...photos);
          gallery.append(disclosure);
        }
        photoDisclosure = gallery?.querySelector('[data-sc-order-photos]');
        mounted = true;
        root.hidden = false;
        form.classList.add('sc-barrel-four-step-form');
        product.querySelector('.sc-build-intro')?.setAttribute('hidden','');
        paintStep(0);
      }
      syncPhotos();
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(mount); } };
    form.addEventListener('input',schedule);
    form.addEventListener('change',schedule);
    next.addEventListener('click',() => { if (validate(step)) paintStep(Math.min(3,step+1),true); });
    back.addEventListener('click',() => paintStep(Math.max(0,step-1),true));
    progress.forEach((button,n) => button.addEventListener('click',() => {
      if (n > step) { for (let i=step;i<n;i++) if (!validate(i)) return; }
      paintStep(n,true);
    }));
    product.addEventListener('click',event => {
      const link = event.target.closest('a[href^="#o_"]');
      if (!mounted || !link) return;
      const page = document.getElementById(link.getAttribute('href').slice(1))?.closest('[data-sc-order-page]');
      if (page) { event.preventDefault(); paintStep(Number(page.dataset.scOrderPage),true); }
    });
    form.addEventListener('invalid',event => {
      if (!mounted) return;
      const page = event.target.closest('[data-sc-order-page]');
      if (page && Number(page.dataset.scOrderPage) !== step) paintStep(Number(page.dataset.scOrderPage),true);
    },true);
    const guard = event => {
      if (!mounted || (event.type === 'click' && !event.target.closest('button[name="add"],input[type="submit"]'))) return;
      for (let i=0;i<pages.length;i++) if (!validate(i)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    };
    // Run ahead of app add-to-cart listeners without replacing their submission path.
    window.addEventListener('click',guard,true);
    form.addEventListener('submit',guard,true);
    new MutationObserver(schedule).observe(form,{childList:true,subtree:true});
    mount();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
